






































import Vue from 'vue'

import { TranslateResult } from 'vue-i18n'

declare interface timeLimitationItem {
  text: string | TranslateResult,
  value: number,
}

export type DataType = {
  timeLimitation: number,
  timeLimitationItems: timeLimitationItem[],
}

export default Vue.extend({
  name: 'CardRoomTime',

  data(): DataType {
    return {
      timeLimitation: 0,
      timeLimitationItems: [
        {
          text: this.$t('CardRoomTime.infinite'),
          value: 0,
        },
        {
          text: '1',
          value: 1,
        },
        {
          text: '2',
          value: 2,
        },
        {
          text: '3',
          value: 3,
        },
        {
          text: '4',
          value: 4,
        },
        {
          text: '5',
          value: 5,
        }, 
        {
          text: '6',
          value: 6,
        },
        {
          text: '7',
          value: 7,
        },
        {
          text: '8',
          value: 8,
        },
        {
          text: '9',
          value: 9,
        },
        {
          text: '10',
          value: 10,
        },          
      ],
    }
  },

  methods: {
    setTimeLimitation() {
      this.$emit('setTimeLimitation', this.timeLimitation)
    },

    cancel() {
      this.$emit('cancel')
    },    
  }
})
